/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Entity} from '@ion/core/src/types/entities';
import AuditDialog, {
  AuditDateFilterProps
} from '@ion/dls/src/editors/audit/AuditDialog';
import {
  ViewAuditChangesDialog
} from '@ion/dls/src/editors/audit/ViewAuditChangesDialog';
import {
  auditDownloadJob,
  showAuditDownloadJobChangesDialog
} from '@/store/actions/downloadjobs';
import {useDownloadJobAudit} from '@/store/hooks/useDownloadJobAudit';

/**
 * Component to provide the display of Audit Logs in Download Job.
 *
 *  ```typescript
 *   import {DownloadJobsAudit} from './DownloadJobsAudit.tsx';
 *
 *   <DownloadJobsAudit />
 *  ```
 */
export const DownloadJobsAudit = ({
  enableDateFilter = false
}: AuditDateFilterProps) => {
  const dispatch = useDispatch();
  const {
    showAuditNotification,
    auditNotification,
    selectedAuditRecord,
    showAuditChangesDialog
  } = useDownloadJobAudit();

  const onAuditClose = useCallback(function() {
    dispatch(auditDownloadJob(null, false));
  }, []);

  const onViewAuditChanges = useCallback(function(auditRecord, show = false) {
    dispatch(showAuditDownloadJobChangesDialog(auditRecord, show));
  }, []);

  const onViewAuditChangesClose = useCallback(function() {
    dispatch(showAuditDownloadJobChangesDialog(null, false));
  }, []);

  return (
    <>
      {showAuditNotification && (
        <AuditDialog enableDateFilter={enableDateFilter}
          enableRangeSelection
          item={auditNotification}
          entity={Entity.job}
          onCloseDialog={onAuditClose}
          onViewAuditChanges={onViewAuditChanges} />
      )}
      {showAuditChangesDialog && selectedAuditRecord && (
        <ViewAuditChangesDialog auditRecord={selectedAuditRecord}
          onCloseDialog={onViewAuditChangesClose}
          entity={Entity.job} />
      )}
    </>
  );
};

export default DownloadJobsAudit;
